var _rect, _rect2, _rect3, _rect4, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path4, _g14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1082_3971)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68.1444,
    height: 5.06058,
    transform: "matrix(1 0 0 -1 79.1152 87.7964)",
    fill: "url(#paint0_linear_1082_3971)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 68.1444,
    height: 5.24188,
    transform: "matrix(1 0 0 -1 79.1152 116.033)",
    fill: "url(#paint1_linear_1082_3971)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72.377,
    y: 59.1215,
    width: 81.6235,
    height: 23.616,
    rx: 4,
    fill: "url(#paint2_linear_1082_3971)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.375,
    y: 87.5756,
    width: 81.6235,
    height: 23.214,
    rx: 4,
    fill: "url(#paint3_linear_1082_3971)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 120C72 117.791 73.7909 116 76 116H150C152.209 116 154 117.791 154 120V135C154 137.209 152.209 139 150 139H76C73.7909 139 72 137.209 72 135V120Z",
    fill: "url(#paint4_linear_1082_3971)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 137C72 135.895 72.8954 135 74 135H154C154 137.209 152.209 139 150 139H74C72.8954 139 72 138.105 72 137Z",
    fill: "#C0C8D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.9881,
    cy: 70.1761,
    r: 2.62094,
    fill: "#BCC2CC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.9881,
    cy: 98.8541,
    r: 2.62094,
    fill: "#F54A59"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.9881,
    cy: 127.53,
    r: 2.62094,
    fill: "#BCC2CC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.2206,
    cy: 70.1761,
    r: 2.62094,
    fill: "#D7DCE5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.2206,
    cy: 98.8541,
    r: 2.62094,
    fill: "#D7DCE5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.2206,
    cy: 127.53,
    r: 2.62094,
    fill: "#D7DCE5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 59,
    width: 16,
    height: 80,
    fill: "#283342"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 7,
    transform: "matrix(1 0 0 -1 34 76)",
    fill: "url(#paint5_linear_1082_3971)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 6,
    transform: "matrix(1 0 0 -1 34 110)",
    fill: "url(#paint6_linear_1082_3971)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 101.102,
    height: 29.2517,
    rx: 4,
    fill: "url(#paint7_linear_1082_3971)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 75.2462,
    width: 101.102,
    height: 28.7537,
    rx: 4,
    fill: "url(#paint8_linear_1082_3971)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 110,
    width: 101,
    height: 30,
    rx: 4,
    fill: "url(#paint9_linear_1082_3971)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 136H127V137.643C127 138.945 125.945 140 124.643 140H28.3572C27.0554 140 26 138.945 26 137.643V136Z",
    fill: "#C3CBD6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.6663,
    cy: 53.6948,
    r: 3.24639,
    fill: "#D7DCE5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.6663,
    cy: 89.2143,
    r: 3.24639,
    fill: "#D7DCE5"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.6663,
    cy: 124.734,
    r: 3.24639,
    fill: "#D7DCE5"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5804,
    cy: 53.6948,
    r: 3.24639,
    fill: "#D7DCE5"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5804,
    cy: 89.2143,
    r: 3.24639,
    fill: "#D7DCE5"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5804,
    cy: 124.734,
    r: 3.24639,
    fill: "#D7DCE5"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_1082_3971)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.622 131.07H81.2605C72.2479 131.07 65 123.767 65 114.75C65 105.161 72.6891 97.4143 82.2058 97.4143H117.185C126.702 97.4143 134.391 105.161 134.391 114.75V121.291C134.328 126.688 129.979 131.07 124.622 131.07Z",
    fill: "url(#paint10_linear_1082_3971)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.08 129.166C116.83 129.166 127.975 117.936 127.975 104.083C127.975 90.23 116.83 79 103.08 79C89.3314 79 78.1855 90.23 78.1855 104.083C78.1855 117.936 89.3314 129.166 103.08 129.166Z",
    fill: "url(#paint11_linear_1082_3971)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_1082_3971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.245 131.071C132.946 131.071 140.001 123.964 140.001 115.196C140.001 106.429 132.946 99.3209 124.245 99.3209C115.543 99.3209 108.488 106.429 108.488 115.196C108.488 123.964 115.543 131.071 124.245 131.071Z",
    fill: "url(#paint12_linear_1082_3971)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.853 105.364L108.827 95L133 119.675L119.68 133L96 108.818L98.4667 105.857L106.853 105.364Z",
    fill: "url(#paint13_linear_1082_3971)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_1082_3971)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3108 98.5152C94.0203 98.225 93.5304 98.3144 93.394 98.7018C93.0502 99.6781 92.8633 100.728 92.8633 101.822C92.8633 107.015 97.0786 111.225 102.279 111.225C103.704 111.225 105.055 110.909 106.266 110.343C106.499 110.233 106.778 110.274 106.961 110.456L112.25 115.739C113.345 116.833 115.12 116.833 116.215 115.739C117.309 114.646 117.309 112.873 116.215 111.78L110.925 106.498C110.743 106.315 110.702 106.035 110.811 105.802C111.377 104.593 111.694 103.244 111.694 101.822C111.694 96.6287 107.478 92.4188 102.279 92.4188C101.184 92.4188 100.132 92.6054 99.1547 92.9487C98.7667 93.0849 98.6772 93.5757 98.9681 93.8662L104.683 99.5741C105.969 100.858 105.969 102.94 104.683 104.224C103.398 105.508 101.313 105.508 100.027 104.224L94.3108 98.5152Z",
    fill: "url(#paint14_linear_1082_3971)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1082_3971",
    x: 7.14213,
    y: 35.2855,
    width: 165.716,
    height: 137.716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.1434
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.42893
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_3971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_3971",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1082_3971",
    x: 78.3672,
    y: 67.5552,
    width: 6.4208,
    height: 6.4205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1082_3971",
    x: 78.3672,
    y: 96.2332,
    width: 6.4208,
    height: 6.4205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.837807 0 0 0 0 0.22541 0 0 0 0 0.279129 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1082_3971",
    x: 78.3672,
    y: 124.909,
    width: 6.4208,
    height: 6.4205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1082_3971",
    x: 89.5996,
    y: 67.5552,
    width: 6.4208,
    height: 6.4205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1082_3971",
    x: 89.5996,
    y: 96.2332,
    width: 6.4208,
    height: 6.4205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1082_3971",
    x: 89.5996,
    y: 124.909,
    width: 6.4208,
    height: 6.4205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1082_3971",
    x: 33.4199,
    y: 50.4484,
    width: 7.6708,
    height: 7.67141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1082_3971",
    x: 33.4199,
    y: 85.968,
    width: 7.6708,
    height: 7.67141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_1082_3971",
    x: 33.4199,
    y: 121.487,
    width: 7.6708,
    height: 7.67141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_1082_3971",
    x: 47.334,
    y: 50.4484,
    width: 7.6708,
    height: 7.67141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_1082_3971",
    x: 47.334,
    y: 85.968,
    width: 7.6708,
    height: 7.67141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_1082_3971",
    x: 47.334,
    y: 121.487,
    width: 7.6708,
    height: 7.67141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156 0 0 0 0 0.208 0 0 0 0 0.26 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_1082_3971",
    x: 55.5711,
    y: 74.2855,
    width: 93.8579,
    height: 70.9293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.71447
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.71447
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.90864 0 0 0 0 0 0 0 0 0 0.0817002 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_3971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_3971",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_1082_3971",
    x: 65,
    y: 97.4143,
    width: 71.7479,
    height: 38.37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.35723,
    dy: 4.71447
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.0717
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_1082_3971",
    x: 108.488,
    y: 99.3209,
    width: 36.2262,
    height: 36.465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.71447,
    dy: 4.71447
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35723
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.98 0 0 0 0 0.986667 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1082_3971"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_1082_3971",
    x: 88.1488,
    y: 90.0615,
    width: 33.6008,
    height: 33.5694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.35723
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35723
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866974 0 0 0 0 0.0815368 0 0 0 0 0.152159 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1082_3971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1082_3971",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1082_3971",
    x1: 1.56294,
    y1: 2.71102,
    x2: 68.0801,
    y2: 0.550567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#C3CAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3CAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1082_3971",
    x1: 1.56294,
    y1: 2.80815,
    x2: 68.0848,
    y2: 0.722264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#C3CAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3CAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1082_3971",
    x1: 74.2491,
    y1: 71.773,
    x2: 154.002,
    y2: 71.1081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1082_3971",
    x1: 74.2471,
    y1: 100.012,
    x2: 154,
    y2: 99.3353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1082_3971",
    x1: 73.8807,
    y1: 128.321,
    x2: 154.001,
    y2: 127.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1082_3971",
    x1: 1.94954,
    y1: 3.75,
    x2: 84.9361,
    y2: 1.31941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#C3CAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3CAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1082_3971",
    x1: 1.94954,
    y1: 3.21429,
    x2: 84.9105,
    y2: 0.37948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#C3CAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3CAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1082_3971",
    x1: 28.3188,
    y1: 55.6705,
    x2: 127.104,
    y2: 54.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#EBEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197793,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1082_3971",
    x1: 28.3188,
    y1: 90.6499,
    x2: 127.103,
    y2: 89.8121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#EBEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197793,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1082_3971",
    x1: 28.3165,
    y1: 126.071,
    x2: 127.002,
    y2: 125.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#EBEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197793,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1082_3971",
    x1: 99.7924,
    y1: 128.94,
    x2: 71.942,
    y2: 99.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317888,
    stopColor: "#FC5B69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1082_3971",
    x1: 116.5,
    y1: 116,
    x2: 86.919,
    y2: 83.6122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414681,
    stopColor: "#FE4E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1082_3971",
    x1: 112.941,
    y1: 104.143,
    x2: 127.108,
    y2: 129.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355396,
    stopColor: "#FF4E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85969,
    stopColor: "#FD4353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1082_3971",
    x1: 100.933,
    y1: 96.4805,
    x2: 122.156,
    y2: 122.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC2739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F72237",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1082_3971",
    x1: 104.957,
    y1: 92.7902,
    x2: 104.957,
    y2: 117.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0243972,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0E3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDown);
export default __webpack_public_path__ + "static/media/service_down.9c43f7fcb887fb4d52a4859eb9facbb7.svg";
export { ForwardRef as ReactComponent };